import type { Account } from '@hero/schema';
import { getObjectId } from '@hero/schema';
import { AccountTransactionListManager } from '../../AccountTransaction/Manager/AccountTransactionListManager';

export interface AccountTransactionsTabProps {
  account: Account;
}

/**
 * `AccountTransaction` rows scoped to a single account. Used by
 * both the `AccountDrawer` and the standalone `AccountPage`
 * (Transactions tab).
 */
export function AccountTransactionsTab({ account }: AccountTransactionsTabProps) {
  return (
    <AccountTransactionListManager
      scopeQuery={{ accountId: getObjectId(account._id) }}
    />
  );
}
